/**
 * Currency formatting utilities for Dhanshika Exports
 * Following Indian numbering system with K/L/Cr notation
 */

export const formatCurrency = (amount: number, options?: {
  showSymbol?: boolean
  precision?: number
  compact?: boolean
}): string => {
  const { showSymbol = true, precision = 0, compact = false } = options || {}
  
  if (compact) {
    return formatCompactCurrency(amount, showSymbol)
  }
  
  const formatter = new Intl.NumberFormat('en-IN', {
    style: showSymbol ? 'currency' : 'decimal',
    currency: 'INR',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  })
  
  return formatter.format(amount)
}

export const formatCompactCurrency = (amount: number, showSymbol: boolean = true): string => {
  const symbol = showSymbol ? '₹' : ''
  
  if (amount >= 10000000) { // 1 Crore
    return `${symbol}${(amount / 10000000).toFixed(1)}Cr`
  } else if (amount >= 100000) { // 1 Lakh
    return `${symbol}${(amount / 100000).toFixed(1)}L`
  } else if (amount >= 1000) { // 1 Thousand
    return `${symbol}${(amount / 1000).toFixed(1)}K`
  } else {
    return `${symbol}${amount.toLocaleString('en-IN')}`
  }
}

export const formatNumber = (num: number, compact: boolean = false): string => {
  if (compact) {
    if (num >= 10000000) { // 1 Crore
      return `${(num / 10000000).toFixed(1)}Cr`
    } else if (num >= 100000) { // 1 Lakh
      return `${(num / 100000).toFixed(1)}L`
    } else if (num >= 1000) { // 1 Thousand
      return `${(num / 1000).toFixed(1)}K`
    }
  }
  
  return num.toLocaleString('en-IN')
}

export const formatPercentage = (value: number, precision: number = 1): string => {
  return `${value.toFixed(precision)}%`
}

export const formatDays = (days: number): string => {
  if (days === 0) return 'Today'
  if (days === 1) return '1 day'
  if (days < 0) return 'Overdue'
  return `${days} days`
}